module.exports = __webpack_public_path__ + "img/client3.ce02b7d9.png";